import React from "react";
import DataTable from "@/components/DataTable";
import { PageHeader } from "@/components/shared";
import { ROLES } from "@/config/trackers";

const columns = [
  { key: "name", label: "Name", type: "text" },
  { key: "email", label: "Google Account Email", type: "text" },
  { key: "role", label: "Role", type: "select", options: "$roles" },
  { key: "department", label: "Department", type: "select", options: "$departments" },
  { key: "business", label: "Business", type: "select", options: "$businesses" },
  { key: "branch", label: "Branch", type: "select", options: "$branches" },
  { key: "joining_date", label: "Joining Date", type: "date" },
  { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
  { key: "contact", label: "Contact Number", type: "text" },
  { key: "remarks", label: "Remarks", type: "text" },
];

export default function Team() {
  return (
    <div>
      <PageHeader title="Team Master List" subtitle="Add members and assign roles — they instantly appear across trackers, the dashboard and the pipeline" />
      <DataTable
        title="Team Members"
        endpoint="team"
        columns={columns}
        globalFilter={false}
        extraColumns={[{ key: "employee_id", label: "Emp ID", render: (r) => <span className="text-gold font-mono text-xs">{r.employee_id}</span> }]}
      />
    </div>
  );
}
